import { BaseService } from 'core/services';
import { CoreUserInfoRouteService } from 'common/data';
import { findParams } from 'core/utils';

class CoreUserInfoService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new CoreUserInfoRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	update(resource, sourceOfChange) {
		var url = this.routeService.update(resource, sourceOfChange);
		return this.apiClient.put(url, resource);
	}
}

export default CoreUserInfoService;
